<div class="card-inner">
    <div class="card-image" [ngClass]="{'company':isCompanyLogo, 'loaded': imageLoaded}"><img src="{{imageUrl}}"
        (error)="updateUrl($event)">
</div>
<div class="card-company">
    <div>{{project.employName}}</div>
    <div *ngIf="city">{{city}}</div>
</div>
<div class="card-title">
    <div><b>{{project.title}}</b></div>
    <span>{{project.positionName | translate}}</span>
</div>
    <div class="card-action">
        <button mat-flat-button color="accent" class="text-uppercase"
            [routerLink]="['/project/',project.id]">{{ 'Ad Details' | translate }}</button>
    </div>
</div>